import { render, staticRenderFns } from "./BaseConfigCard.vue?vue&type=template&id=e050a59e&scoped=true"
import script from "./BaseConfigCard.vue?vue&type=script&lang=ts"
export * from "./BaseConfigCard.vue?vue&type=script&lang=ts"
import style0 from "./BaseConfigCard.vue?vue&type=style&index=0&id=e050a59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e050a59e",
  null
  
)

export default component.exports